import {INotification} from "@/interfaces/notification.interface";

export namespace IProfilePayment {
  export enum Action {
    BankCards = 'bank_cards',
    CarsForPayment = 'CarsForBankCards',
  }

  export enum Command {
    Add = 'add',
    Get = 'get',
    Delete = 'del',
    AddAllFavoriteCars = 'addAllFavoriteCars',
    StartNewCard = 'startNewCard',
    CardList = 'cardList',
    SetDefault = 'setDefault',
    RemoveCard = 'unBindCard',
    SetSettings = 'setBankAutoPayFlag',
    GetCheck = 'getFiscalLink',
    GetBankPays = 'getBankPaysOne',
  }

  export enum NoticeKey {
    SaveCard = 'saveCard',
    Status = 'status',
  }

  export interface ICardData {
    id: number;
    cardName: string;
    dftFlag: boolean;
    bankName: string;

    cashCard?: boolean;
  }

  export const BankNames = [
    'alfa',
    'sberbank',
    'tinkoff',
    'vtb',
    'ozon',
    'expobank',
    'raiffeisen',
    'otp',
    'sovcom',
    'gazprom',
    'mts',
  ];

  export enum Events {
    UpdateCountsCarsPayment = 'profile:updateCountsCarsPayment',
  }
}

export const ProfileNoticeData: any = {
  [IProfilePayment.NoticeKey.SaveCard]: {
    [IProfilePayment.NoticeKey.Status]: {
      [INotification.NoticeStatus.Success]: {
        title: 'Успешно',
        text: 'Карта успешно привязана',
      },
      [INotification.NoticeStatus.Error]: {
        title: 'Ошибка',
        text: 'Не удалось привязать карту, попробуйте еще раз',
      }
    },
  },
};